import { render } from "./EmployeeDataLayout.vue?vue&type=template&id=44ce6148&scoped=true"
import script from "./EmployeeDataLayout.vue?vue&type=script&lang=js"
export * from "./EmployeeDataLayout.vue?vue&type=script&lang=js"

import "./EmployeeDataLayout.vue?vue&type=style&index=0&id=44ce6148&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce6148"]])

export default __exports__